import axios from 'axios';
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.permissions;
const roleUrl = endpointNames.roles;

let token = JSON.parse(localStorage.getItem('token'));

const addPermission = async (request) => {
    let response;
    await axios.post(baseUrl.create, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const getAll = async () => {
    let response;
    await axios.get(baseUrl.get, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const getPermission = async (id) => {
    let response;
    await axios.get(baseUrl + "/" + id)
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const getUnAssignedPermission = async () => {
    let response;
    await axios.get(baseUrl.get, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}
const getAssignedPermission = async (groupId) => {
    let response;
    await axios.get(roleUrl.getRole + "show/" + groupId, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const assignPermission = async (request) => {
    let response;
    await axios.post(roleUrl.assign, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

const unAssignPermission = async (request) => {
    console.log(request);
    let response;
    await axios.post(roleUrl.unAssign, request, {
        headers: {Authorization: `Bearer ${token}`}
    })
        .then(res => {
            response = res;
        }).catch(err => {
            console.log(err);
            response = err;
        });

    return response
}

export default {
    getPermission, getUnAssignedPermission, getAssignedPermission, getAll, assignPermission,
    unAssignPermission, addPermission
}
